import React from 'react';
import { Col, Button } from 'react-bootstrap';
import Lottie from 'lottie-react';
import celebration from 'components/lottie/celebration.json';
import styles from 'assets/scss/wizard/emetSuccess.module.scss';

const SuccessHeader = ({ onFinish }) => (
	<Col className="text-center">
		<div className="wizard-lottie-wrapper">
			<div className="wizard-lottie mx-auto">
				<Lottie animationData={celebration} loop />
			</div>
		</div>
		<h4 className="mb-1">You have finished!</h4>
		<p className="fs-0">You have successfully completed your test</p>
		<Button
			variant="primary"
			size="lg"
			onClick={onFinish}
			className={styles.skipButton}
		>
			Finished
		</Button>
	</Col>
);

export default SuccessHeader;